import Vue from 'vue'
const EventBus = new Vue()
export default EventBus



// WEBPACK FOOTER //
// ./resources/assets/js/frontend-vue/plugins/event-bus.js